import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { VIEW_TYPE } from '../components/xml-preview/constants';

type ContextProps = {
	validationErrors: any;
	setValidationErrors: (value: any) => void;
	viewType: string;
	setViewType: (value: string) => void;
};

type ContextProviderProps = {
	children: ReactNode;
};

const XMLTabContext = createContext<ContextProps>({
	validationErrors: {},
	setValidationErrors() {},
	viewType: VIEW_TYPE.TABLE,
	setViewType() {},
});

export const XMLTabContextProvider = ({ children }: ContextProviderProps) => {
	const [validationErrors, setValidationErrors] = useState<any>({});
	const [viewType, setViewType] = useState<string>(VIEW_TYPE.TABLE);

	return (
		<XMLTabContext.Provider
			value={{
				validationErrors,
				setValidationErrors,
				viewType,
				setViewType,
			}}
		>
			{children}
		</XMLTabContext.Provider>
	);
};

export const useXMLTabContext = () => useContext(XMLTabContext);
